import * as HttpService from './http.service';
import * as URL from './url.service';

export const createSuggestion = (resourceId, data) => HttpService.postWithAuth(URL.CREATE_SUGGESTION_URL(resourceId), data);

export const updateSuggestionStatus = (id, data) => HttpService.putWithAuth(URL.UPDATE_SUGGESTION_STATUS_URL(id), data);

export const withdrawSuggestion = (id) => HttpService.putWithAuth(URL.WITHDRAW_SUGGESTION_URL(id));
export const bulkWithdrawSuggestionsAndProposals = (data) => HttpService.putWithAuth(URL.BULK_WITHDRAW_SUGGESTION_PROPOSAL_URL(), data);
export const getDemandSuggestions = (id) => HttpService.getWithAuth(URL.GET_DEMAND_SUGGESTIONS_URL(id));

export const updateSuggestion = (id, data) => HttpService.putWithAuth(URL.UPDATE_SUGGESTION_URL(id), data);

export const getSuggestionShiftTimings = (suggestionId) => HttpService.getWithAuth(URL.GET_SUGGESTION_SHIFT_TIMINGS_BY_SUGGESTION_ID({ suggestionId }));
